import React, { useContext, useEffect, useState } from 'react'
import { FaGraduationCap, FaUserTie } from 'react-icons/fa'
import { MdAddToPhotos, MdAppRegistration } from 'react-icons/md'
import { PiBagFill } from 'react-icons/pi'
import CandidateInfoAddCard from '../../components/Cards/CandidateInfoAddCard'
import { HiLightBulb } from 'react-icons/hi'
import { RiVideoFill } from 'react-icons/ri'
import VideoPlayer from '../../components/VideoJS/VideoPlayer'
import { IoLanguage } from 'react-icons/io5'
import CandidateInfoEditCard from '../../components/Cards/CandidateInfoEditCard'
import employerContext from '../../hooks/employerContext'

const EmployerCandidateProfile = ({ rightSideContent, initialGlow, categorySelectedGlow, cardSelectedGlow }) => {

  const { employerExpertNotes, recommendedDatas } = useContext(employerContext);
  const [about, setAbout] = useState('');
  const [experience, setExperience] = useState([]);
  const [education, setEducation] = useState([]);
  const [preference, setPreference] = useState('');
  const [video, setVideo] = useState('');
  const [language, setLanguage] = useState([]);
  const [socialLinks, setSocialLinks] = useState([]);
  const [additionalInfo, setAdditionalInfo] = useState('');
  const [skills, setSkills] = useState([]);
  const dummyLanguage = [1, 2, 3];
  const dummyskills = [1, 2, 3, 4, 5, 6, 7, 8]
  const [pageContentLoaded, setPageContentLoaded] = useState(!initialGlow && !categorySelectedGlow && !cardSelectedGlow)


  useEffect(() => {
    if (pageContentLoaded) {
      if (rightSideContent.about !== undefined) {
        setAbout(rightSideContent.about);
      }
      if (rightSideContent.experience !== undefined) {
        setExperience(rightSideContent.experience);
      }
      if (rightSideContent.education !== undefined) {
        setEducation(rightSideContent.education);
      }
      if (rightSideContent.preferences !== undefined) {
        setPreference(rightSideContent.preferences);
      }
      if (rightSideContent.video_name !== undefined) {
        setVideo(rightSideContent.video_name)
      }
      if (rightSideContent.languages !== undefined) {
        setLanguage(rightSideContent.languages)
      }
      if (rightSideContent.additional_info !== undefined) {
        setAdditionalInfo(rightSideContent.additional_info)
      }
      if (rightSideContent.skills !== undefined) {
        setSkills(rightSideContent.skills)
      }
      if (rightSideContent.social_link !== undefined) {
        setSocialLinks(rightSideContent.social_link)
      }
    } else {
      setAbout('');
      setExperience([]);
      setEducation([]);
      setPreference('');
      setVideo('');
      setLanguage([]);
      setAdditionalInfo('');
      setSkills([]);
    }
  }, [rightSideContent])


  const [isVideoUploaded, setIsVideoUploaded] = useState(false)
  const [videoFullyUploaded, setVideoFullyUploaded] = useState(false)



  return (
    <>
      <div className="container">
        {
          pageContentLoaded ?
            recommendedDatas.recommended_by === "2nd careers recommended" && recommendedDatas.sc_recommended_notes !== "" ?
              <div className="alert alert-box-brandColor w-100 mt-3" role="alert">
                <h5 className="job-title-weight">Recommendation comments</h5>
                <p>{recommendedDatas.sc_recommended_notes}</p>
              </div>
              :
              null
            :
            null
        }
      </div>


      <CandidateInfoEditCard
        pageContentLoaded={pageContentLoaded}
        cardHeadingIcon={<FaUserTie className={pageContentLoaded ? "me-4 brand-color fs-4" : "me-3 fs-4 placeholder rounded-2 p-3"} />}
        cardHeading="About"
        placeholder="About placeholder"
        cardContent={about}
      />

      <CandidateInfoAddCard
        pageContentLoaded={pageContentLoaded}
        cardHeadingIcon={<PiBagFill className={pageContentLoaded ? "me-4 brand-color fs-4" : "me-3 fs-4 placeholder rounded-2 p-3"} />}
        cardHeading="Experience"
        placeholder="Experience placeholder"
        arrayContent={experience}
      />

      <CandidateInfoAddCard
        pageContentLoaded={pageContentLoaded}
        cardHeadingIcon={<FaGraduationCap className={pageContentLoaded ? "me-4 brand-color fs-4" : "me-3 fs-4 placeholder rounded-2 p-3"} />}
        cardHeading="Education"
        placeholder="Education placeholder"
        arrayContent={education}
      />


      {
        pageContentLoaded ?
          skills.length > 0 ?
            <div className="card border-0">
              <div className="card-body">
                <div className="d-flex justify-content-between ms-1">
                  <label className="profile-side-headers d-flex align-items-center placeholder-glow">
                    <HiLightBulb className="me-4 brand-color fs-4" />
                    <span>
                      Skills
                    </span>
                  </label>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="row row-cols-auto ms-5 g-3 profile-descriptions mt-3">
                    {
                      skills.map((skill, index) => {
                        return (
                          <div className="col mt-0" key={index}>
                            <div className="employer-card-skills border rounded-2 p-2 fw-bold mb-4">
                              {skill.skill_name} {skill.skill_level ? "-" : null} {" "}
                              <span className="fw-normal">
                                {skill.skill_level}
                              </span>
                            </div>
                          </div>
                        );
                      })
                    }
                  </div>
                </div>
              </div>
            </div>
            :
            null
          :
          <div className="card border-0">
            <div className="card-body">
              <div className="d-flex justify-content-between ms-1">
                <label className="profile-side-headers d-flex align-items-center placeholder-glow">
                  <HiLightBulb className="me-3 fs-3 placeholder rounded-2 p-3"
                  />
                  <span className={"placeholder px-5 w-100 py-3 d-inline-block rounded-1"} ></span>
                </label>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <div className="row row-cols-auto ms-5 g-3 profile-descriptions mt-3">
                  {dummyskills.map((skill, index) => {
                    return (
                      <div className="col mt-0" key={index}>
                        <div className="employer-card-skills border rounded-2 p-2 fw-bold mb-4 px-5 py-1 placeholder">
                          <span className="px-3"></span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
      }


      <CandidateInfoEditCard
        pageContentLoaded={pageContentLoaded}
        cardHeadingIcon={<MdAppRegistration className={pageContentLoaded ? "me-4 brand-color fs-4" : "me-3 p-3 fs-4 placeholder rounded-2"} />}
        cardHeading="Preference"
        placeholder="Preference placeholder"
        cardContent={preference}
      />


      <div className="row mt-2 g-3 ">
        {
          pageContentLoaded ?
            video !== "" ?
              <div className="col-12 col-md-6 mb-3 mb-sm-0">
                <div className="card border-0">
                  <div className="card-body">
                    <div className={`d-flex justify-content-between ms-1 ${videoFullyUploaded || video.includes('.mp4') ? "mb-2" : ""}`}>
                      <label className="profile-side-headers d-flex align-items-center">
                        <RiVideoFill className="me-4 brand-color fs-3" />
                        <span>
                          Video
                        </span>
                      </label>
                    </div>
                    <div className="d-flex justify-content-center mb-4">
                      <VideoPlayer
                        uploadedVideoFile={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${video}`}
                        isVideoUploaded={isVideoUploaded}
                      />
                    </div>
                  </div>
                </div>
              </div>
              :
              null
            :
            <div className="col-12 col-md-6 mb-3 mb-sm-0">
              <div className="card border-0">
                <div className="card-body">
                  <div className={`d-flex justify-content-between ms-1`}>
                    <label className="profile-side-headers d-flex align-items-center">
                      <RiVideoFill className="me-3 p-3 fs-4 placeholder rounded-2" />
                      <span className="placeholder px-5 w-100 py-3 w-100 rounded-1" ></span>
                    </label>
                  </div>
                  <div className='placeholder py-5 mt-3 w-100 rounded-2'>
                    <div className="py-5">
                      <div className="py-4"></div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
        }

        {
          pageContentLoaded ?
            language.length > 0 ?
              <div className="col col-md-6">
                <div className="card border-0">
                  <div className="card-body">
                    <div className="d-flex justify-content-between ms-1">
                      <label className="profile-side-headers d-flex align-items-center">
                        <IoLanguage className={"me-4 brand-color fs-4"} />
                        <span>
                          Languages
                        </span>
                      </label>
                    </div>
                    <div className="ms-5 mt-3 ">
                      {language.map((language, index) => {
                        return (
                          <div  key={index}>
                            <div className="d-flex justify-content-between">
                              <label className="profile-inner-headers">
                                {language.language_known}
                              </label>
                            </div>
                            <p className="mt-1 profile-descriptions">
                              {language.language_level}
                            </p>
                            <hr />
                          </div>
                        );
                      })
                      }
                    </div>
                  </div>
                </div>
              </div>
              :
              null
            :
            <div className="col col-md-6">
              <div className="card border-0">
                <div className="card-body">
                  <div className="d-flex justify-content-between ms-1">
                    <label className="profile-side-headers d-flex align-items-center">
                      <IoLanguage className="me-3 p-3 fs-4 placeholder rounded-2" />
                      <span className="placeholder px-5 w-100 py-3 w-100 rounded-1" ></span>
                    </label>
                  </div>
                  <div className="ms-5 mt-3 ">
                    {dummyLanguage.map((language,ind) => {
                      return (
                        <div key={ind}>
                          <div className="d-flex justify-content-between">
                            <label className="profile-inner-headers placeholder rounded-2 py-3 w-25"></label>
                          </div>
                          <p className="mt-1 profile-descriptions placeholder rounded-2 py-2 pb-3 w-100"></p>
                          <hr />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
        }

        {
          pageContentLoaded ?
            socialLinks.length > 0 ?
              <div className="col col-md-6">
                <div className="card border-0">
                  <div className="card-body">
                    <div className="d-flex justify-content-between ms-1">
                      <label className="profile-side-headers d-flex align-items-center">
                        <IoLanguage className={"me-4 brand-color fs-4"} />
                        <span>
                          Social Links
                        </span>
                      </label>
                    </div>
                    <div className="ms-5 mt-3 ">
                      {socialLinks.map((socialLink, socialLinkIndex) => {
                        return (
                          <div key={socialLinkIndex}>
                            <div className="d-flex justify-content-between" key={socialLink.id}>
                              <label className="profile-inner-headers">
                                {socialLink.title}
                              </label>
                            </div>
                            <a href={(socialLink.url).includes("https://") ? socialLink.url : `https://${socialLink.url}`} className="mt-1 profile-descriptions text-primary" target='_blank'>
                              {(socialLink.url).includes("https://") ? socialLink.url : `https://${socialLink.url}`}
                            </a>

                            <hr />
                          </div>
                        );
                      })
                      }
                    </div>
                  </div>
                </div>
              </div>
              :
              null
            :
            <div className="col col-md-6">
              <div className="card border-0">
                <div className="card-body">
                  <div className="d-flex justify-content-between ms-1">
                    <label className="profile-side-headers d-flex align-items-center">
                      <IoLanguage className="me-3 p-3 fs-4 placeholder rounded-2" />
                      <span className="placeholder px-5 w-100 py-3 w-100 rounded-1" ></span>
                    </label>
                  </div>
                  <div className="ms-5 mt-3 ">
                    {dummyLanguage.map((language,ind) => {
                      return (
                        <div key={ind}>
                          <div className="d-flex justify-content-between">
                            <label className="profile-inner-headers placeholder rounded-2 py-3 w-25"></label>
                          </div>
                          <p className="mt-1 profile-descriptions placeholder rounded-2 py-2 pb-3 w-100"></p>
                          <hr />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
        }
      </div>

      {
        pageContentLoaded ?
          additionalInfo.length > 0 ?
            <div className="card border-0 mt-2">
              <div className="card-body ">
                <div className="d-flex justify-content-between ms-1">
                  <label className="profile-side-headers d-flex align-items-center">
                    <MdAddToPhotos className={"me-4 brand-color fs-4"} />
                    <span >
                      Additional Information
                    </span>
                  </label>
                </div>

                <div className="ms-5 mt-3">
                  {additionalInfo.map((info, index) => {
                    return (
                      <div key={index}>
                        <div className="additional-information">
                          <div className="d-flex justify-content-between ">
                            <label className="profile-inner-headers ">
                              {info.title}
                            </label>
                          </div>
                          <ul className="mt-1 profile-descriptions">
                            <li>
                              <p className='text-break'>{info.description}</p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    );
                  })
                  }
                </div>
              </div>
            </div>
            :
            null
          :
          <div className="card border-0 mt-2">
            <div className="card-body ">
              <div className="d-flex justify-content-between ms-1">
                <label className="profile-side-headers d-flex align-items-center">
                  <MdAddToPhotos className={"me-3 p-3 fs-4 placeholder rounded-2"} />
                  <span className={"placeholder px-5 w-100 py-3 rounded-1"} > </span>
                </label>
              </div>

              <div className="ms-5 mt-3">
                <p className={"text-grey placeholder py-5 w-100 rounded-2"}>
                  <span className='my-5 d-inline-block'></span>
                </p>
              </div>
            </div>
          </div>
      }

      {
        pageContentLoaded ?
          employerExpertNotes !== "" ?
            <div className="col-12 py-3 px-4">
              <div className="container"></div>
              <h5 className="job-title-weight">Notes from 2nd Careers Experts</h5>
              <div className="alert alert-box-brandColor w-100 mt-3" role="alert">
                {employerExpertNotes}
              </div>
            </div>
            :
            null
          :
          null
      }

    </>
  )
}

export default EmployerCandidateProfile;